<div class="flex-row full align-start position-relative content-between height-100-pr">
  <button type="button" class="btn color-secondary close-modal" (click)="closeDialog(false)"
    aria-label="Close Risk mismatch"><img src="assets/new-assets/icons/icon-close-black.svg" alt="Close icon"
      aria-hidden="true" class="height-15-px width-15-px height-md-12-px width-md-12-px"></button>
  <div class="flex-row align-center height-100-pr column-md">
    <div class=" bg-secondary height-100-pr flex-row content-between mt-30">
      <img src="assets/new-assets/illustrations/risk-level-mismatch-popup.svg" alt="Risk mismatch">
    </div>
    <div class="flex-row full p-35 column risk-mismatch p-md-20">
      <h1 mat-dialog-title class="fs-25 fw-7">Risk Level Mismatched</h1>
      <div mat-dialog-content class="fs-14 ls-1 fw-4 mt-20">The risk level of your selected pack is higher than your
        risk tolerance level as in your risk
        profile questionnaire. If it is your intention to proceed with the request, please confirm the following:</div>
      <div mat-dialog-content class="fs-14 ls-1 fw-4 mt-20">Despite the fact that the risk level of my selected call may
        not be suitable for me based on my
        risk profile questionnaire. I confirm that it is my intention & desire to proceed with my request.</div>
      <div class="flex-row full content-center">
        <button type="button" class="btn btn-primary mt-20 full-md" (click)="closeDialog(true)">I Understand</button>
      </div>
    </div>
  </div>
</div>